module.exports = require("core-js/es7/object");


//////////////////
// WEBPACK FOOTER
// external "core-js/es7/object"
// module id = 3
// module chunks = 0